module.exports = __webpack_public_path__ + "img/icon-btn-plus.e745c011.svg";